"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = EditViewName;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Cancel2 = _interopRequireDefault(require("@material-ui/icons/Cancel"));

var _InputBase2 = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _IconView = _interopRequireDefault(require("./IconView"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

EditViewName.propTypes = {
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onUpdate: _propTypes["default"].func,
  setShowInputView: _propTypes["default"].func
};

function EditViewName(_ref) {
  var setShowInputView = _ref.setShowInputView,
      name = _ref.name,
      id = _ref.id,
      type = _ref.type,
      onUpdate = _ref.onUpdate;

  var _useState = (0, _react.useState)(name),
      _useState2 = _slicedToArray(_useState, 2),
      newName = _useState2[0],
      setName = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      padding: 3
    }
  }, /*#__PURE__*/_react["default"].createElement(_IconView["default"], {
    type: type
  }), /*#__PURE__*/_react["default"].createElement("form", {
    style: {
      marginLeft: "5px"
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
        id: id,
        name: newName
      });
      setShowInputView(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_InputBase2["default"], {
    style: {
      border: "1px solid rgba(209, 213, 219,1)",
      borderRadius: "0.25rem",
      paddingLeft: "0.25rem",
      height: 30,
      fontSize: "0.875rem",
      width: 130
    },
    margin: "none",
    autoFocus: true,
    value: newName,
    onChange: function onChange(e) {
      return setName(e.target.value);
    },
    inputProps: {
      maxLength: 255
    }
  })), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      display: "flex",
      alignItems: "center",
      marginLeft: "0.5rem",
      cursor: "pointer"
    },
    onClick: function onClick() {
      return setShowInputView(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Cancel2["default"], {
    fontSize: "small"
  })));
}